import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class TokenService {
  constructor() {}

  setTokens(primaryToken: any, secondaryToken: any, email: string): void {
    const { clientId, clientIdSecondary } = environment;

    localStorage.setItem(
      `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`,
      email
    );
    localStorage.setItem(
      `CognitoIdentityServiceProvider.${clientId}.${email}.clockDrift`,
      '0'
    );

    if (primaryToken) {
      const key = `CognitoIdentityServiceProvider.${clientId}.${email}`;
      localStorage.setItem(`${key}.expiresat`, primaryToken.expiresat);
      localStorage.setItem(`${key}.accessToken`, primaryToken.accesstoken);
      localStorage.setItem(`${key}.idToken`, primaryToken.idtoken);
      if (primaryToken.refreshtoken)
        localStorage.setItem(`${key}.refreshToken`, primaryToken.refreshtoken);
    }

    if (secondaryToken) {
      const key = `CognitoIdentityServiceProvider.${clientIdSecondary}.${email}.2`;
      localStorage.setItem(`${key}.accessToken`, secondaryToken.accesstoken);
      localStorage.setItem(`${key}.idToken`, secondaryToken.idtoken);
      if (secondaryToken.refreshtoken)
        localStorage.setItem(
          `${key}.refreshToken`,
          secondaryToken.refreshtoken
        );

      const legacyKey = `CognitoIdentityServiceProvider.${clientIdSecondary}.${email}.secondary`;
      localStorage.removeItem(`${legacyKey}.accessToken`);
      localStorage.removeItem(`${legacyKey}.idToken`);
      localStorage.removeItem(`${legacyKey}.refreshToken`);
    }
  }

  deleteTokens(): void {
    const { clientId, clientIdSecondary } = environment;

    const email = localStorage.getItem(
      `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`
    );
    localStorage.removeItem(
      `CognitoIdentityServiceProvider.${clientId}.${email}.clockDrift`
    );

    const key = `CognitoIdentityServiceProvider.${clientId}.${email}`;
    localStorage.removeItem(`${key}.expiresat`);
    localStorage.removeItem(`${key}.accessToken`);
    localStorage.removeItem(`${key}.idToken`);
    localStorage.removeItem(`${key}.refreshToken`);

    const secondaryKeys = [
      `CognitoIdentityServiceProvider.${clientIdSecondary}.${email}.2`,
      `CognitoIdentityServiceProvider.${clientIdSecondary}.${email}.secondary`,
    ];
    secondaryKeys.forEach((key) => {
      localStorage.removeItem(`${key}.accessToken`);
      localStorage.removeItem(`${key}.idToken`);
      localStorage.removeItem(`${key}.refreshToken`);
    });

    localStorage.removeItem(
      `CognitoIdentityServiceProvider.${clientId}.LastAuthUser`
    );
  }
}
